module.exports = __webpack_public_path__ + "img/list-product.a287672.svg";